export default "__VITE_ASSET__BT_cc6o0__"